import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
    validate: {
        id: 'validate',
        defaultMessage: 'Validate',
    },
    validateStay: {
        id: 'validate-stay',
        defaultMessage: 'Validate stay',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    stayValidated: {
        id: 'stay-validated',
        defaultMessage: 'Stay validated',
    },
    stayValidatedDescription: {
        id: 'stay-validated-description',
        defaultMessage: 'The stay was successfully validated',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    validation: {
        id: 'validation',
        defaultMessage: 'Validation',
    },
    activeStayPeriod: {
        id: 'active-stay-period',
        defaultMessage: 'Active stay period',
    },
    pastStayPeriod: {
        id: 'past-stay-period',
        defaultMessage: 'Past stay period',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    search: {
        id: 'search',
        defaultMessage: 'Search',
    },
    pastValidations: {
        id: 'past-validations',
        defaultMessage: 'Past validations',
    },
    validatedAmount: {
        id: 'validated-amount',
        defaultMessage: 'Validated amount',
    },
    validatedTime: {
        id: 'validated-time',
        defaultMessage: 'Validated time',
    },
});
